module.exports = __webpack_public_path__ + "img/家禽.d1aa41e4.png";